export const environment = {
  production: true,
  version: '4.60.0-alpha.26',
  topdeskUrl: 'https://myservicedesk.simac.nl/tas/secure/mango/incident',
};
